import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#FFFFFF]">
      <div className="w-full max-w-sm">
        <Link to="/login" className="flex flex-col items-center gap-3 mb-8">
          <img src="/dftb26-mark.png" alt="" className="h-20 w-20 object-contain" />
          <img src="/dftb26-logo-dark.png" alt="DFTB26 - Back to Basics" className="h-12 w-auto object-contain" />
        </Link>
        <h1 className="font-display text-3xl mb-1 text-center">Forgot password?</h1>
        <p className="text-sm text-[#5a5a5a] mb-6 text-center">
          {submitted
            ? "Check your email - if that address has an account, a reset link is on its way."
            : "Enter the email you used to sign up and we'll send you a link to set a new password."}
        </p>

        {!submitted ? (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-12 rounded-sm mt-1"
                data-testid="forgot-email-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="w-full h-12 rounded-sm bg-[#000000] text-[#FFFFFF] hover:bg-[#1c1c24] font-semibold"
            >
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        ) : (
          <div className="p-4 bg-[#000000]/5 border border-[#000000]/20 rounded-sm text-sm text-[#1c1c24] leading-relaxed" data-testid="forgot-success">
            <p>The link is valid for <strong>60 minutes</strong>. If it doesn&apos;t arrive in a few minutes, check your spam folder.</p>
            <p className="mt-2 text-xs text-[#7A828C]">Still stuck? Email <a href="mailto:hello@dftbdigital.com" className="text-[#000000] hover:underline">hello@dftbdigital.com</a>.</p>
          </div>
        )}

        <p className="text-sm text-[#5a5a5a] text-center mt-6">
          Remembered it?{" "}
          <Link to="/login" className="text-[#000000] hover:underline" data-testid="forgot-back-login">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
